// NX skeleton placeholder: a pulsing block in the track colour, used to mirror the final layout while data loads.
import type * as React from "react";

import { cn } from "@/lib/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn("animate-pulse rounded-sm bg-track", className)}
      {...props}
    />
  );
}

export { Skeleton };
